export const WIDGET_TYPES = {
    CONTAINER: 'container',
    EPISODE_STATUS: 'episodeStatus',
    EPISODE_COSTS: 'episodeCosts',
    GLOBAL_STATUS: 'globalStatus',
    GLOBAL_COSTS: 'globalCosts',
};
